import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { SWASTHCONFIG } from '../../config';
import { SWASTH_CONST } from '../constant';
import {Storage} from "@ionic/storage";
import {JwtHelperService} from "@auth0/angular-jwt";
import { tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

const FOLLOWUP_URL = SWASTHCONFIG.FOLLOWUP_URL;
const SERVER_URL = SWASTHCONFIG.SERVER_URL;
const SWASTHPLUS = SWASTHCONFIG.SWASTHPLUS;
const PATIENT_URL = SWASTHCONFIG.PATIENT_URL;
const DOCTOR_URL = SWASTHCONFIG.DOCTOR_URL;
const HOSPITAL_URL = SWASTHCONFIG.HOSPITAL_URL;
const NURSE_URL = SWASTHCONFIG.NURSE_URL;
const DX_URL = SWASTHCONFIG.DX_URL;
const PHARMACY_URL = SWASTHCONFIG.PHARMACY_URL;
const MEDICINE_URL = SWASTHCONFIG.MEDICINE_URL;
const LOOKUP_URL = SWASTHCONFIG.LOOKUP_URL;
const VITAL_URL = SWASTHCONFIG.VITAL_URL;
const RECP_URL = SWASTHCONFIG.RECP_URL;
const PRESC_TEMPLATE = SWASTHCONFIG.PRESC_TEMPLATE;
const SEND_MEDICINE = SWASTHCONFIG.SEND_MEDICINE;
const SEND_DXCENTER = SWASTHCONFIG.SEND_DXCENTER;
const SEND_NURSE = SWASTHCONFIG.SEND_NURSE;
const SEND_DOCTOR = SWASTHCONFIG.SEND_DOCTOR;
const APPOINTMENT_URL = SWASTHCONFIG.APPOINTMENT_URL;
const UPLOAD_URL = SWASTHCONFIG.UPLOAD_URL;
const DOWNLOAD_URL = SWASTHCONFIG.DOWNLOAD_URL;
const PAYMENT_URL = SWASTHCONFIG.PAYMENT_URL;
const BILL_URL = SWASTHCONFIG.BILL_URL;
const S3BASE_URL=SWASTHCONFIG.S3BASE_URL;
const HEADER_LOGO=SWASTHCONFIG.HEADER_LOGO;
const SITE_URL=SWASTHCONFIG.SITE_URL;
const razorpaymode=SWASTHCONFIG.RAZORPAYMODE;
const PRESCRIPTION_URL = SWASTHCONFIG.PRESCRIPTION_URL;

@Injectable({
  providedIn: 'root'
})
export class ModulesApisService {

  S3BASE_URL = S3BASE_URL;
  decodedToken:any;
  logo_url=HEADER_LOGO;
  site_url=SITE_URL;
  razorpayMode = razorpaymode;
  expiryDisclymStatus = SWASTHCONFIG.EXPIRYDISCLAIMERSTS;

  
  authUser = new ReplaySubject<any>(1);
  private jwtTokenName ='jwt_token';

  constructor(private readonly httpClient: HttpClient,
     private readonly storage: Storage,
      private readonly jwtHelper: JwtHelperService
      ) {
    
   }

  // new user sign up
  signup(values: any): Observable<any> {
    return this.httpClient.post(`${PATIENT_URL}/signup`, values, {responseType: 'text'});
      /*.pipe(tap(jwt => {
        console.log("response===="+jwt);
        if (jwt !== 'EXISTS') {          
          return this.handleJwtResponse(jwt);          
        }
        return jwt;
      }));*/
  }

  // new user sign up
  circlesignup(values: any): Observable<any> {
    return this.httpClient.post(`${LOOKUP_URL}/sccirclepatientsignupsc`, values, {responseType: 'text'});
      /*.pipe(tap(jwt => {
        console.log("response===="+jwt);
        if (jwt !== 'EXISTS') {          
          return this.handleJwtResponse(jwt);          
        }
        return jwt;
      }));*/
  }

  // check user logged in
  checkLogin() {
    this.storage.get(this.jwtTokenName).then(jwt => { 
      if (jwt && !this.jwtHelper.isTokenExpired(jwt)) {
        this.authUser.next(jwt);        
      } else {
        console.log("JWT False"+jwt);
        this.storage.remove(this.jwtTokenName).then(() => this.authUser.next(null));
      }
    });
  }  

  // user session login 
  login(values: any,rememberValues:any): Observable<any> {
    return this.httpClient.post(`${SERVER_URL}/circlelogin`, values, {responseType: 'text'})
    .pipe(tap(jwt => {
      if(jwt !== 'NOTEXISTS'){
        if(rememberValues==1)
        {
          return this.handleJwtResponse(jwt);
        }else{         
          this.authUser.next(jwt);
        }
      }
      return jwt;
    }));      
  }

  // forget password
  forgotUidCheck(ptID: any){
    return this.httpClient.get(`${SERVER_URL}/checkuid/`+ptID, {responseType: "json"});
  }

  // user logout session
  logout() {
    this.storage.remove(this.jwtTokenName).then(() => this.authUser.next(null));
  }

  // store jwt Token
  private handleJwtResponse(jwt: string) {  
    return this.storage.set(this.jwtTokenName,jwt)
      .then(() => this.authUser.next(jwt))
      .then(() => jwt);    
  }

  // get Patient detail by uid
  patientdetail(values: any) {        
    var epurl=LOOKUP_URL+"/scgetcirclepatientdetailssc/"+values;       
    return this.httpClient.get(epurl, {responseType: "json"});          
  }

  //patient address api
  getAddressByUser(userid:any){
    var epurl=PATIENT_URL+"/useraddress/"+userid;
    //console.log("url......"+epurl);
    return this.httpClient.get(epurl, {responseType: "json"});
  }

  // update patient profile
  update(values: any, user: any): Observable<any> {
    var url=PATIENT_URL;
    return this.httpClient.put(`${LOOKUP_URL}/update/`+user, values, {responseType: 'text'});      
  } 


  // edit/add address of patiient
  addAddress(values:any){
    var epurl=PATIENT_URL+"/addaddress";
    return this.httpClient.post(epurl, values, {responseType: "text"});
  }

  // seperate family member account into seperate
  separateAccount(value:any, mobno:String): Observable<any> {
    let url=PATIENT_URL+"/updatesplitaccount/"+mobno;
    return this.httpClient.put(url, value, {responseType: 'text'});
  }

  // View Health Alert
  viewHealthAlert(): Observable<any> {
    var epurl=LOOKUP_URL+"/scviewhealthalertssc";
    //console.log("url......"+epurl);    
    let alertList= this.httpClient.get(epurl, {responseType: "json"});
    //console.log(ptlist);
    return alertList;
  }

  // Get Server Time

  getServerTime()
  {
    let url = LOOKUP_URL+"/getServerDateTime/";
    return this.httpClient.get(url, {responseType: "text"});
  }

  // Get Circle Family Members
  getCircleFamilyMembersListByCircleCode(ptprimaryuserid) {
    var epurl=LOOKUP_URL+"/getcirclefamilymembersbycirclecode/"+ptprimaryuserid;
    return this.httpClient.get(epurl, {responseType: "json"});
    
  }

  // Get Circle Family Members By Userid and Circle Code
  getCircleFamilyMembersListByCircleCodeAndPtuid(ptprimaryuserid,circlecode) {
    var epurl=LOOKUP_URL+"/getcirclefamilymembersuseridcirclecode/"+ptprimaryuserid+"/"+circlecode;
    return this.httpClient.get(epurl, {responseType: "json"});
  }

  // Add Single Circle Family Member
  addCircleSingleFamilyMember(familyMember:any) {
    let url = LOOKUP_URL+"/scaddcirclesinglefamilymembersc";
    return this.httpClient.post(url,familyMember, {responseType: "text"});
  } 

  // get agora video call details
  getAgoraVideoDetails(circlecode,doctoruid,patientuid){
    let url = LOOKUP_URL+"/getagoradetails/"+circlecode+"/"+doctoruid+"/"+patientuid;
    return this.httpClient.get(url, {responseType: "json"});
  }

  // get agora video call details by patient uid
  getAgoraVideoDetailsByPatientuserid(patientuid)  {
    let url = LOOKUP_URL+"/getagoradetailsbyptuid/"+patientuid;
    return this.httpClient.get(url, {responseType: "json"});
  }

  // get doctor profile by userid
  getDoctorProfile(docuserID: any){
    ////console.log("Doctor---"+docuserID);    
    return this.httpClient.get(`${DOCTOR_URL}/profile/`+docuserID, {responseType: "json"});
  }

  // get clinic doctor profile by userid
  getClinicDoctorProfile(docuserID, tenantid){
    ////console.log("Doctor---"+docuserID);    
    return this.httpClient.get(`${DOCTOR_URL}/getclinicdocprofile/`+docuserID+`/`+tenantid, {responseType: "json"});
  }

  //  get all doctor video time session for week
  getAllDocVideoTimeSessionForWeek(sessObj) {
    console.log("sess obj", JSON.stringify(sessObj));
    let url = SWASTHPLUS+"/getalldocvideotimesessionforweek";
    return this.httpClient.put(url,sessObj, {responseType: "json"});
  } 

  //  get all doctor clinic time session for week
  getAllDocClinicTimeSessionForWeek(sessObj) {
    console.log("sess obj", JSON.stringify(sessObj));
    let url = SWASTHPLUS+"/getalldocclinictimesessionforweek";
    return this.httpClient.put(url,sessObj, {responseType: "json"});
  }
  
  //  get all doctor clinic time session for week
  getSingleDoctorClinicTimeSessionForWeek(sessObj) {
    console.log("sess obj", JSON.stringify(sessObj));
    let url = SWASTHPLUS+"/getsingledoctorclinictimesessionforweek";
    return this.httpClient.put(url,sessObj, {responseType: "json"});
  }

  //  get doctor video time session for week
  getDocVideoTimeSessionForWeek(sessObj) {
    console.log("sess obj", sessObj);
    let url = SWASTHPLUS+"/getdocvideotimesessionforweek";
    return this.httpClient.put(url,sessObj, {responseType: "json"});
  } 

  //  get doctor clinic time session for week
  getDocClinicTimeSessionForWeek(sessObj) {
    console.log("sess obj", sessObj);
    let url = SWASTHPLUS+"/getdocclinictimesessionforweek";
    return this.httpClient.put(url,sessObj, {responseType: "json"});
  } 

  // save clinic appt
  saveClinicAppt(apptobj) {
    let url = SWASTHCONFIG.SWASTHPLUS+"/saveclinicappt";
    return this.httpClient.post(url, apptobj, {responseType: "json"});
  }

  // save swasthplus video appt
  saveVideoAppt(videoObj) {
    let url = SWASTHPLUS+"/saveswasthvideobookappt";
    return this.httpClient.post(url,videoObj, {responseType: "text"});
  } 

  // save swasthplus video appt
  saveVideoAppt1(videoObj) {
    let url = SWASTHPLUS+"/saveswasthvideobookappt1";
    return this.httpClient.post(url,videoObj, {responseType: "json"});
  } 

  // update swasthplus video appt
  updateVideoApptComplaint(complaintobj:any){
    let url = SWASTHPLUS+"/updatevideocomplaint";
    return this.httpClient.post(url,complaintobj, {responseType: "text"});
  }

  savePtVideoPresence(saveobj, mobno) {
    var epurl=PATIENT_URL+"/saveptvideopresence/"+mobno;
    return this.httpClient.put(epurl, saveobj, {responseType: "text"});
  }

  updatePtVideoPresence(saveobj, mobno) {
    var epurl=PATIENT_URL+"/updateptvideopresence/"+mobno;
    return this.httpClient.put(epurl, saveobj, {responseType: "text"});
  }

  getPtVideoPresence(mobno) {
    var epurl=PATIENT_URL+"/getptvideopresence/"+mobno;
    return this.httpClient.get(epurl, {responseType: "json"});
  }

  // get patient profile by userid
  getPatientProfile(ptUserId: any){
    ////console.log("Doctor---"+docuserID);    
    return this.httpClient.get(`${LOOKUP_URL}/scgetcirclepatientdetailssc/`+ptUserId, {responseType: "json"});
  }

  // get circle obj and  circle doctor list
  getCircleDocListByCcode(circleName) {
    var epurl=FOLLOWUP_URL+"/getptcircleentydoclist/"+circleName;
    console.log("epurl", epurl);
    return this.httpClient.get(epurl, {responseType: "json"});
  }

  // get circle obj and  circle doctor list
  getCircleDocListByCnamePtuid(circleName, ptuid) {
    var epurl=FOLLOWUP_URL+"/getptcircleentydoclistbycname/"+circleName+"/"+ptuid;
    console.log("epurl", epurl);
    return this.httpClient.get(epurl, {responseType: "json"});
  }

  // get followup plans by circle code doctor uid and status
  getFollowupsPlanByDocCcode(ccode, docuid, status): Observable<any> {
    var epurl=FOLLOWUP_URL+"/getplanfrsubscp/"+ccode+"/"+docuid+"/"+status;
    console.log("epurl---"+epurl);
    return this.httpClient.get(epurl, {responseType: 'json'});
  }

  // check circle subscribed by patient or not
  checkPatientSubscribedInCircle(userid,circlecode) {
    let url = FOLLOWUP_URL+"/checkpatientsubscribedincircle/"+userid+"/"+circlecode;
    return this.httpClient.get(url, {responseType: "json"});
  }

  // create subscribe entry before pay patientt circle, chat, chatrestrict, subscribehistory
  createSubscribeBeforePay(subscribeObj, subscpType) {
    var epurl=FOLLOWUP_URL+"/savescriptionobjcircle/"+subscpType+"/"+this.razorpayMode;
    return this.httpClient.put(epurl, subscribeObj, {responseType: "json"});
  }

  // update subscribe entry after pay patientt circle, chat, chatrestrict, subscribehistory
  updateSubscribeDetailAfterPay(subscribeObj) {
    var epurl=FOLLOWUP_URL+"/upatescriptionobj";
    return this.httpClient.post(epurl, subscribeObj, {responseType: "text"});
  }

  razorpayAmtTransToDocAccViaPayment(routeObj){
    routeObj.payMode = this.razorpayMode;
    var epurl=FOLLOWUP_URL+ '/getpaydetailposttodocacc';    
    return this.httpClient.post(epurl, routeObj, {responseType: "json"});
  }

  // get patient subscribed circle code list
  getPtCircleList(ptuid:any) {
    let url = FOLLOWUP_URL+"/getptcirclecodelist/"+ptuid;
    console.log("url", url);
    return this.httpClient.get(url, {responseType: "json"});
  }

  // save followup clinic appt
  saveFollowUpClinicAppt(apptList) {
    let url = SWASTHPLUS+"/savefollowupclinicappt";
    console.log("Appt Api",url);
    return this.httpClient.post(url,apptList, {responseType: "text"});
  }
  
  // upload to s3
  uploadFileToS3(uploadObj) {
    let url = UPLOAD_URL + '/api/file/lockdownupload';
    return this.httpClient.post(url, uploadObj, {responseType: "text"});
  }

  // check circle patient mobileno, email
  checkPtMobRegEmail(obj)
  {
    var epurl=LOOKUP_URL+"/sccheckptmobemailsc";
    return this.httpClient.put(epurl, obj, {responseType: "json"});
  }

  // get patient subscribed single circle detail
  getPtSingleCircle(ccode, ptuid:any) {
    let url = FOLLOWUP_URL+"/getptsingcircle/"+ccode+"/"+ptuid;
    console.log("url", url);
    return this.httpClient.get(url, {responseType: "json"});
  }

  // add vchat complaints
  addChatComplaint(chatcomplaintobj) {
    var epurl=FOLLOWUP_URL+"/addvchatcomplaint";
    return this.httpClient.post(epurl, chatcomplaintobj, {responseType: "json"});
  }

  gePtAllVideoAppt(ptuid) {
    let url = SWASTHPLUS+"/getptallvideoapptlist/"+ptuid;
    return this.httpClient.get(url, {responseType: "json"});
  }

  gePtnocomplaintVideoAppt(ptuid) {
    let url = SWASTHPLUS+"/getvideoappointmentnocomplaint/"+ptuid;
    return this.httpClient.get(url, {responseType: "json"});
  }

  createSwasthVideoChatRoom(videoObj) {
    var epurl=SWASTHCONFIG.SWASTHPLUS+"/createswasthvideochatroom";
    return this.httpClient.post(epurl, videoObj, {responseType: "text"});
  }

  // update video appt
  updateVideoAppt(apptList) {
    let url = SWASTHPLUS+"/updateswasthvideoappt";
    return this.httpClient.post(url,apptList, {responseType: "text"});
  }

  // get followup chat restric detail 
  getFollowupChatPageDetail(obj:any): Observable<any> {
    let url = FOLLOWUP_URL+"/getfollowupchatdetail";
    return this.httpClient.put(url, obj, {responseType: "json"});
  }

  prescriptionVital(dxid: any): Observable<any> {
    var epurl=MEDICINE_URL+"/vital/"+dxid;
    return this.httpClient.get(epurl, {responseType: "json"});
  }

  //Add QR Code
  getQrCode(values: any): Observable<any> {
    var epurl=MEDICINE_URL+"/getqrcode/"+values;
    return this.httpClient.get(epurl,{responseType: "json"});
  }

  // generate pdf servic side retun key
  pdfGenerate(pdfObj, dxid) {
    var epurl=MEDICINE_URL+"/pdfgenerate/"+dxid;
    return this.httpClient.put(epurl, pdfObj, {responseType: 'text'});
  }

  getDocumentKeyName(documentID:any){
    var epurl=UPLOAD_URL+"/get_keyname/"+documentID;
    return this.httpClient.get(epurl, {responseType: "text"});
  }

  // get virtual circle detail by circle code
  getCircleDetailByCode(circlecode) {
    return this.httpClient.get(`${LOOKUP_URL}/scgetvcircledocbycodesc/`+circlecode, {responseType: "json"});
  }

  // get circle entity by circle code
  getCircleEntity(circleCode) {
    let url = LOOKUP_URL+"/scgetcirclesc/"+circleCode;
    return this.httpClient.get(url, {responseType: "json"});
  }

  // single prescription 
  uniquePrescription(values: any): Observable<any> {
    var epurl=MEDICINE_URL+"/unique/"+values;
    return this.httpClient.get(epurl, {responseType: "json"});
  }

  // single prescription
  getcirclePatientByMobno(ptmobileno): Observable<any> {
    var epurl=FOLLOWUP_URL+"/getcircleptbymobno/"+ptmobileno;
    return this.httpClient.get(epurl, {responseType: "json"});
  }

  

  // check doctor patient video consultation chat room key
  checkDocPtVideoConsulChatroomDetail(ptuid,docuid,tenantid)
  {
    let url = SWASTHPLUS+"/ckdocptvideochtrm/"+ptuid+"/"+docuid+"/"+tenantid;
    return this.httpClient.get(url, {responseType: "json"});
  }

  // get login entity for otp login
  checkloginOtp(ptmobileno)
  {
    let url = SERVER_URL+"/loginotp/"+ptmobileno;
    return this.httpClient.get(url, {responseType: "json"});
  }

  //	swasth single doc video appt waiting room pt save
  savePtVideoWaitingRoom(videoobj) {
    var epurl=SWASTHPLUS+"/savevideoapptinwaitingroom";
    return this.httpClient.post(epurl, videoobj, {responseType: 'text'});
  }

  //	get patient token number of waiting room
  getTokenNumber(ptuid,docuid,tenantid,date) {
    let url = SWASTHPLUS+"/gettokennumber/"+ptuid+"/"+docuid+"/"+tenantid+"/"+date;
    console.log("url", url);
    return this.httpClient.get(url, {responseType: "json"});
  }

  // update followup patient otp for login
  upadtePatientOtpForLogin(mobileno, otp) {
    let url = SERVER_URL+"/updateotp/"+mobileno+"/"+otp;
    // console.log("url", url);
    return this.httpClient.put(url, {responseType: "json"});
  }

  // update followup patient otp for login
  checkOtpPassValid(mobileno, otp) {
    let url = SERVER_URL+"/checkotp/"+mobileno+"/"+otp;
    // console.log("url", url);
    return this.httpClient.get(url, {responseType: "json"});
  }

  getPrescripedMedicinesByDxid(ptdxid:any)
  {
    var epurl=SWASTHCONFIG.PRESCRIPTION_URL+"/getprescripedmedicinesforbill/"+ptdxid;
    return this.httpClient.get(epurl,{responseType: 'json'});
  }

  getPrescripedMedicinesByDxidbranch(ptdxid:any,branchcode:any)
  {
    var epurl=SWASTHCONFIG.PRESCRIPTION_URL+"/getprescripedmedicinesforbillbranch/"+ptdxid+"/"+branchcode;
    return this.httpClient.get(epurl,{responseType: 'json'});
  }

























































  


















  
  
  
  
  
  
  





































  
  // patientcircle app apis without modification
  //	get plan details based on plan id
  getPlanDetails(planid) {
    var epurl=LOOKUP_URL+"/getplandetailsbyid/"+planid;
    return this.httpClient.get(epurl, {responseType: "json"});
  }

  // chat room doctor single day consultation time
  getCircleDocTimeSession(obj) {
    var epurl=LOOKUP_URL+"/getcircledoctimeSessionbydateorweek";
    return this.httpClient.put(epurl, obj, {responseType: "json"});
  }

  // get circle video appt of patient
  getVideoApptOfPt(apptObj) {
    var epurl=LOOKUP_URL+"/getvideoapptofpatient";
    return this.httpClient.put(epurl, apptObj,{responseType: "json"});
  }

  // Get Plan Price
  getPlanPrice(planid)
  {
    let url = LOOKUP_URL+"/getplanprice/"+planid;
    return this.httpClient.get(url, {responseType: "json"});
  }  

  //	create razorpay order for consultaton payment
  createConsultPayOrder(orderObj): Observable<any> {
    let epurl="";
    if(this.razorpayMode=='Live') {
      epurl=LOOKUP_URL+"/scconsultordersc";
    } else {
      epurl=LOOKUP_URL+"/sctestconsultordersc";
    }
    return this.httpClient.post(epurl, orderObj, {responseType: "json"});
  }

  // get pt chat restriction detail
  getChatRestrictDetail(value:any) {
    let url = LOOKUP_URL+"/scgetptchatrestricdetailsc";
    return this.httpClient.put(url, value, {responseType: "json"});
  }

  // save circle video consultation appointment
  saveCircleVideoAppt(consultObj) {
    var epurl=LOOKUP_URL+"/savecirclevideoappt";
    return this.httpClient.put(epurl, consultObj, {responseType: "text"});
  }

  // create bill for virtual consultation
  createBillForVideoConsultationAppt(billobj:any): Observable<any> {
    console.log("chat obj---",billobj); 
    let url = LOOKUP_URL+"/sccreatebillforvideoconsultsc";
    return this.httpClient.post(url, billobj, {responseType: "json"});
  }

  // send push notification to doctor and patient
  sendPushNotification(notifobj) {
    let url = LOOKUP_URL+"/circlesend";
    return this.httpClient.post(url, notifobj, {responseType: "text"});
  }

  // get video appointment count by patient uid, circle code and date for one time consult payment 
  getApptCountByPtuidCcodeDate(ptuid, subscbdate, ccode): Observable<any> {
    var epurl=LOOKUP_URL+"/getvideoapptcountofsingconsul/"+ptuid+"/"+subscbdate+"/"+ccode;
    console.log("url-->",epurl);
    return this.httpClient.get(epurl, {responseType: 'json'});
  }

  // lockdown upload Prescription
  uploadPrescriptionToS3(body){
    var epurl=UPLOAD_URL + '/api/file/lockdownupload';
    //console.log("url......"+epurl);
    return this.httpClient.post(epurl, body, {responseType: "text"});
  }

  getHospitalDetailsByTenantid(tenantid:any){
    var epurl=HOSPITAL_URL+"/hospitalprofile/"+tenantid;
    //console.log("url......"+epurl);
    return this.httpClient.get(epurl, {responseType: "json"});
  }

  // get swasth subscribe plan list
  getSubscribPlanList() {
    var epurl=LOOKUP_URL+"/scgetplanmastersc";
    return this.httpClient.get(epurl, {responseType: "json"});
  }

  downloadDocumentByKeyname(keyname:any) {
    var pf_url=DOWNLOAD_URL+"/api/file/"+keyname;
    // debugger;       
    return this.httpClient.get(pf_url, {responseType: "text"});
  }

  // get single circle healthlocker prescription list
  singleCirclePrescriptionList(userid:any, search:any){
    var epurl=MEDICINE_URL+"/circleprescriptionlist/"+userid;
    return this.httpClient.put(epurl, search, {responseType: "json"});
  }

  // get patient chat by patient userid and circle code
  getPatientChatByPatientUserid(userid,circleCode) {
    let url = LOOKUP_URL+"/scgetpatientchatsc/"+userid+"/"+circleCode;
    return this.httpClient.get(url, {responseType: "json"});
  }

  // Send Video Appointment SMS to Doctor
  sendVideoApptSMSToDoctor(drMobile, patientName, scheduleDate, doctorName, websiteLink) {
    var epurl=LOOKUP_URL+"/sendvideoappointmentsmsdoctor/"+drMobile+"/"+patientName+"/"+scheduleDate+"/"+doctorName+"/"+websiteLink;
    return this.httpClient.get(epurl, {responseType: 'json'});
  }

  // Send Video Appointment SMS to Doctor
  sendVideoApptSMSToPatient(ptMobile, patientName, scheduleDate, doctorName, websiteLink) {
    var epurl=LOOKUP_URL+"/sendvideoappointmentsmspatient/"+ptMobile+"/"+patientName+"/"+scheduleDate+"/"+doctorName+"/"+websiteLink;
    return this.httpClient.get(epurl, {responseType: 'json'});
  }

  // Send Plus Video Appointment SMS to Doctor
  sendPlusVideoApptSMSToDoctor(drMobile, patientName, scheduleDate, doctorName) {
    var epurl=LOOKUP_URL+"/sendplusvideoappointmentsmsdoctor/"+drMobile+"/"+patientName+"/"+scheduleDate+"/"+doctorName;
    console.log("dsdsds doctor"+epurl);
    return this.httpClient.get(epurl, {responseType: 'json'});
  }

  // Send Plus Video Appointment SMS to Patient
  sendPlusVideoApptSMSToPatient(ptMobile, patientName, scheduleDate, doctorName) {
    var epurl=LOOKUP_URL+"/sendplusvideoappointmentsmspatient/"+ptMobile+"/"+patientName+"/"+scheduleDate+"/"+doctorName;
    console.log("dsdsds patient"+epurl);
    return this.httpClient.get(epurl, {responseType: 'json'});
  }

  // Send Plus Video Appointment SMS to Doctor
  sendWaitingRoomVideoApptSMSToDoctor(drMobile, patientName, scheduleDate, doctorName) {
    var epurl=LOOKUP_URL+"/sendwaitingromvideoappointmentsmsdoctor/"+drMobile+"/"+patientName+"/"+scheduleDate+"/"+doctorName;
    console.log("dsdsds doctor"+epurl);
    return this.httpClient.get(epurl, {responseType: 'json'});
  }

  // Send Plus Video Appointment SMS to Patient
  sendWaitingRoomVideoApptSMSToPatient(ptMobile, patientName, scheduleDate, doctorName) {
    var epurl=LOOKUP_URL+"/sendwaitingromvideoappointmentsmspatient/"+ptMobile+"/"+patientName+"/"+scheduleDate+"/"+doctorName;
    console.log("dsdsds patient"+epurl);
    return this.httpClient.get(epurl, {responseType: 'json'});
  }

  // triage reference doctor
  triageRefDoctor(triageobj:any) {
    var epurl=LOOKUP_URL+"/sctriagetodoctorchatsc";
    return this.httpClient.post(epurl, triageobj, {responseType: 'json'});
  }

  // get patient subscribed single circle 
  // getPtSingleCircle(ccode, ptuid:any) {
  //   let url = LOOKUP_URL+"/scgetptsinglecirclesc/"+ccode+"/"+ptuid;
  //   return this.httpClient.get(url, {responseType: "json"});
  // }

  // check subscription expire date
  checkPtSubscpExpireSt(obj:any): Observable<any> {
    let url=LOOKUP_URL+"/scchecksubexpirestsc";
    return this.httpClient.post(url, obj, {responseType: 'json'});
  }

  // get patiet single circle manual subscription renewal validity
  getPtsingCirRenewalStatus(subscpObj): Observable<any> {
    let epurl=LOOKUP_URL+"/scsincirmanualrenewchecksc";
    return this.httpClient.put(epurl, subscpObj, {responseType: "json"});
  }

  // check tagging created for patient by userid ccode docuserid planid
  checkTaggingForPatient(ptuid,planid,docuid,ccode): Observable<any> {
    var epurl=LOOKUP_URL+"/checktagforpt/"+ptuid+"/"+docuid+"/"+planid+"/"+ccode;
    console.log("hffy->",epurl);
    return this.httpClient.get(epurl, {responseType: "json"});
  }

  // Update Patient walk through status
  updateWalkthroughStatus(ptprofile) {
    let url = LOOKUP_URL+"/updatewtstatus";
    return this.httpClient.put(url, ptprofile, {responseType: "json"});
  }

  // get mobile country code list
  getCountryCodes() {
    var epurl=LOOKUP_URL+"/sccountrycodessc";
    return this.httpClient.get(epurl, {responseType: "json"});
  }

  // download document as base64 by keyname
  downloadDocumentAsBase64ByKeyname(keyname:any)
  {
    var pf_url=DOWNLOAD_URL+"/api/prescriptionfile/"+keyname;
    //console.log(pf_url);
    // debugger;       
    return this.httpClient.get(pf_url, {responseType: "text"});
  }

  // get followup clinic appt
  getFollowUpClinicAppt(ptUid, circCode) {
    let url = SWASTHPLUS+"/getptfollowupappt/"+ptUid+"/"+circCode;
    return this.httpClient.get(url,{responseType: "json"});
  }

  // update pdf keyname for followup handbook
  updatehandbookKey(hbObj): Observable<any> {
    var epurl=LOOKUP_URL+"/scupatekeyofhbsc";
    return this.httpClient.post(epurl, hbObj, {responseType: 'json'});
  }

  // Update Patient hand book followup and appointment
  updateHandBookApptPayst(apptobj,st) {
    let url = LOOKUP_URL+"/updatehbapptpayst/"+st;
    return this.httpClient.put(url, apptobj, {responseType: "json"});
  }

  // check followup clinical appointment after one week for patient
  checkFollowClinicalApptAfterOneWeek(ptuserid): Observable<any>
  {
    let url = FOLLOWUP_URL+"/ckfollowapptaow/"+ptuserid;
    return this.httpClient.get(url,  {responseType: "json"});
  }

  // Update Patient followup multiple tag appointment
  updateHandBookTaggedApptPaystByPt(updateObj)
  {
    let url = LOOKUP_URL+"/updatetagapptpayst";
    return this.httpClient.put(url, updateObj, {responseType: "text"});
  }

  // Update Patient followup multiple clinical apptointment 
  updateHandBookFupApptPaystByPt(updateObj)
  {
    let url = LOOKUP_URL+"/updatefupapptpayst";
    return this.httpClient.put(url, updateObj, {responseType: "text"});
  }

  
  // send email 
  sendPlusVideoApptEmail(sendObj){
    var epurl=LOOKUP_URL+"/email";
    return this.httpClient.put(epurl, sendObj, {responseType: "text"});
  }

  // get Patient RTC Token
  getPatientRTCToken(patientuid,channelName)
  {
    var epurl=LOOKUP_URL+"/getrtctokenpatient/"+patientuid+"/"+channelName;
    return this.httpClient.get(epurl,{responseType: 'text'});
  }



//	get family member list of primary user for plus
  getPrimaryUserFamilyMemb(puid) {
    var epurl=PATIENT_URL+"/getprimaryuserfamilymemb/"+puid;
    return this.httpClient.get(epurl,{responseType: 'json'});
  }

  //	save family member list of primary user for plus
  savePlusFamilyMemb(famObj){
    var epurl=PATIENT_URL+"/saveplusfamilymemb";
    return this.httpClient.put(epurl, famObj, {responseType: "json"});
  }

  // get circle patient details by mobile number
  getCirclePatientDetailsByMobileNumber(mobilenumber)
  {
    let url = LOOKUP_URL+"/getcirclepatientprofile/"+mobilenumber;
    return this.httpClient.get(url, {responseType: "json"});
  }

  // save  otp
  saveOtp(otpobj) {
    var epurl=LOOKUP_URL+"/saveotp";
    return this.httpClient.post(epurl, otpobj, {responseType: 'json'});
  }

  // send otp
  sendOtp(mobilenumber,otp)
  {
    let url = LOOKUP_URL+"/sendotpmsg/"+mobilenumber+"/"+otp;
    return this.httpClient.get(url, {responseType: "json"});
  }

  // Get Otp
  getOtp(mobilenumber)
  {
    let url = LOOKUP_URL+"/getotp/"+mobilenumber;
    return this.httpClient.get(url, {responseType: "json"});
  }

  // Get Otp Record
  getOtpRecord(mobilenumber)
  {
    let url = LOOKUP_URL+"/getotprecord/"+mobilenumber;
    return this.httpClient.get(url, {responseType: "json"});
  }

  // Update New OTP
  updateNewOtp(mobilenumber,status,otp)
  {
    let url = LOOKUP_URL+"/updatenewotp/"+mobilenumber+"/"+status+"/"+otp;
    return this.httpClient.put(url, {responseType: "text"});
  }

  // Update Circle Patient Update New Password
  updateCirclePatientPassword(pass,mobilenumber)
  {
    let url = LOOKUP_URL+"/resetcirclepatientpassword/"+pass+"/"+mobilenumber;
    return this.httpClient.put(url, {responseType: "text"});
  }

  // Send Video Appointment SMS to Doctor

  sendPlusApptSMSToPatient(ptMobile, patientName, scheduleDate, doctorName,hospitalPhoneNumber)
  {
    var epurl=LOOKUP_URL+"/sendplusclinicappointmentsmspatient/"+ptMobile+"/"+patientName+"/"+scheduleDate+"/"+doctorName+"/"+hospitalPhoneNumber;
    console.log("body", epurl);
    return this.httpClient.get(epurl, {responseType: 'json'});
  }

  sendPlusSMS(templateId,mobileNo, var0, var1, var2, var3)
  {
    let postObj:any = JSON.stringify({
      template_id: templateId,
      short_url: '1',
      recipients: [{mobiles: mobileNo, var: var0, var1: var1, var2: var2, var3:var3}]
    });
    let obj:any={
      post:postObj
    }
    var epurl=LOOKUP_URL+"/sendmessage91";
    console.log("body", epurl, postObj);
    return this.httpClient.put(epurl, obj, {responseType: 'json'});
  }

  getBranchNameList(tenantid:any){
    var epurl=HOSPITAL_URL+"/getbranchlist/"+tenantid;
    //console.log("url......"+epurl);
    return this.httpClient.get(epurl, {responseType: "json"});
  }

  getDoctorProfileByName(doctorobj:any)
{
  let url = DOCTOR_URL+"/getdoctorprofilebydoctorname";
  return this.httpClient.post(url,doctorobj, {responseType: "json"});
}

getDoctorProfileByName1(doctorobj:any)
  {
    let url = DOCTOR_URL+"/getdoctorprofilebydoctorname";
    return this.httpClient.post(url,doctorobj, {responseType: "json"});
  }

//  get all doctor video time session for week
getSingleDocVideoTimeSessionForWeek(sessObj) {
  console.log("sess obj", JSON.stringify(sessObj));
  let url = SWASTHPLUS+"/getsingledocvideotimesessionforweek";
  return this.httpClient.put(url,sessObj, {responseType: "json"});
} 

getDocClinicTimeSessionForWeek1(sessObj) {
  console.log("sess obj", sessObj);
  let url = SWASTHPLUS+"/getdocclinictimesessionforweek";
  return this.httpClient.put(url,sessObj, {responseType: "json"});
} 

getPatientAppointmentforchatroom(ptuid:any,docuid:any,tenantid:any) {
  console.log(docuid+","+ptuid+","+tenantid);
  var epurl =SWASTHPLUS + "/getpatientappointmentsbyuid/"+docuid+"/"+ptuid+"/"+tenantid;
  return this.httpClient.get(epurl, { responseType: "json" });    
}

getBranchDetails(branchCode:any)
  {
    var epurl=SWASTHCONFIG.PHARMACY_URL+"/getbranchmasterbycode/"+branchCode;
    return this.httpClient.get(epurl,{responseType: 'json'});
  }

  getPatientAllPrescriptionList(userid,tenantid){
    var epurl=PRESCRIPTION_URL+"/getptpastprescriptionlistbyuserid/"+userid+"/"+tenantid;
    return this.httpClient.put(epurl, {responseType: 'json'})
  }

  getPatientPrescriptionByDxid(dxid:any){
    var epurl=PRESCRIPTION_URL+"/getprescriptionbydxid/"+dxid;
    return this.httpClient.put(epurl, {responseType: 'json'})
  }

  getHospitalPateintProfile(userid:any,tenantid:any):Observable<any>{
    var epurl=PATIENT_URL+"/gethospitalpatient/"+userid+"/"+tenantid;
    return this.httpClient.get(epurl, {responseType: "json"});
  }

  // get case photo list by user
  getCasePhotosByUser(userid,tenantid,casePhotoid){
    var epurl=PRESCRIPTION_URL+"/getcasephotobyuser/"+userid+"/"+tenantid+"/"+casePhotoid;
    return this.httpClient.get(epurl, {responseType: 'json'});
  }

  // get case photo list by user
  getCasePhotosByDate(userid,tenantid,createdDate){
    var epurl=PRESCRIPTION_URL+"/getcasephotobydate/"+userid+"/"+tenantid+"/"+createdDate;
    return this.httpClient.get(epurl, {responseType: 'json'});
  }

  // save case photos
  saveCasePhotos(casephotoobj){
    var epurl=PRESCRIPTION_URL+"/savecasephotos";
    return this.httpClient.post(epurl, casephotoobj, {responseType: 'json'});
  }  

  // get case photo list by user
  checkVideoAppointmentSetting(tenantid,branchcode){
    var epurl=DOCTOR_URL+"/checkvideoappointmentenabled/"+tenantid+"/"+branchcode;
    return this.httpClient.get(epurl, {responseType: 'text'});
  }

  // add bill without amountt list
  addBilling(billobj:any){
    var epurl=BILL_URL+"/addbill";
    //console.log("url......"+epurl);
    return this.httpClient.post(epurl, billobj, {responseType: "json"});
  }

  updateBillDocumentKey(billId:any, documentkey:any){
    var epurl=BILL_URL+"/updatebilldocumentkey/"+billId+"/"+documentkey;
    //console.log("url......"+epurl);
    return this.httpClient.get(epurl, {responseType: "text"});
  }

  sendTeleconsultNotificationToPatient(searchTerm){
    var epurl=PATIENT_URL+"/teleconsultpatientnotification";
    return this.httpClient.put(epurl, searchTerm, {responseType: "text"})
    .pipe(
      catchError((err) => {
        SWASTH_CONST.apiErrorHandling(err);
        return throwError(err); 
      })
    )
  }

  sendTeleconsultNotificationToDoctor(searchTerm){
    var epurl=PATIENT_URL+"/teleconsultdoctornotification";
    return this.httpClient.put(epurl, searchTerm, {responseType: "text"})
    .pipe(
      catchError((err) => {
        SWASTH_CONST.apiErrorHandling(err);
        return throwError(err); 
      })
    )
  }

  getPateintVideoApptChatRoom(doctoruid:any,userid:any,tenantid:any):Observable<any>{
    var epurl=SWASTHPLUS+"/getpatientvideoapptchatroom/"+doctoruid+"/"+userid+"/"+tenantid;
    return this.httpClient.get(epurl, {responseType: "json"});
  }

   // save agora video call details
   saveAgoraVideoCallDetails(agoraObj){
    var epurl=LOOKUP_URL+"/saveagoradetails";
    console.log("url......"+epurl);
    return this.httpClient.post(epurl, agoraObj, {responseType: "json"});
  }

  

  // get agora video call details by patient uid
  getAgoraVideoDetailsByPatientuseridDoctor(tenantid:any,doctoruid:any,patientuid:any)  {
    let url = LOOKUP_URL+"/getagoradetails/"+tenantid+"/"+doctoruid+"/"+patientuid;
    return this.httpClient.get(url, {responseType: "json"});
  }

  //  get doctor clinic time session for week website
  getDocClinicTimeSessionForWeekWebsite(sessObj) {
    console.log("sess obj", sessObj);
    let url = SWASTHPLUS+"/getdocclinictimesessionweekforwebsite";
    return this.httpClient.put(url,sessObj, {responseType: "json"});
  }
  //  check clinic appointmetns
  checkAppointmentsByPatientName(sessObj) {
    console.log("sess obj", JSON.stringify(sessObj));
    let url = SWASTHPLUS+"/checkappointmentinsamedate";
    return this.httpClient.put(url,sessObj, {responseType: "json"});
  } 

  //  get single doctor clinic week or separate time session normal or web slots single day or date(next previous)
  getSingleDocClinicTimeSessionSingleDayWebsite(sessObj) {
    console.log("sess obj", JSON.stringify(sessObj));
    let url = SWASTHPLUS+"/getsingledocdayclinicsesswebsite";
    return this.httpClient.put(url,sessObj, {responseType: "json"});
  }

  //  get all doctor clinic time session for day web slots
  getAllDocClinicTimeSessionSingleDayWebSlots(sessObj) {
    console.log("sess obj", JSON.stringify(sessObj));
    let url = SWASTHPLUS+"/getalldocclinictimesesssingledaywebslots";
    return this.httpClient.put(url,sessObj, {responseType: "json"});
  }

  //  get all doctor clinic time session for day web slots
  getSingleDocClinicTimeSessionSingleDayWebSlots(sessObj) {
    console.log("sess obj", JSON.stringify(sessObj));
    let url = SWASTHPLUS+"/getsingledocclinictimesesssingledaywebslots";
    return this.httpClient.put(url,sessObj, {responseType: "json"});
  }

  //  get all doctor clinic time session for day web slots
  getVideoSlotsSingleDocsingleDay(sessObj) {
    console.log("sess obj", JSON.stringify(sessObj));
    let url = SWASTHPLUS+"/getsingledocdayvideosesswebsite";
    return this.httpClient.put(url,sessObj, {responseType: "json"});
  }

  // save patient otp details
  savePatientOtpDetails(ptotpdetails:any){
    var epurl=PATIENT_URL+"/savepatientotpverification";
    console.log("url......"+epurl);
    return this.httpClient.post(epurl, ptotpdetails, {responseType: "json"});
  }

  // get patient otp details by mobile number
  getPatientOtpDetails(mobilenumber:any)  {
    let url = PATIENT_URL+"/getpatientotp/"+mobilenumber;
    return this.httpClient.get(url, {responseType: "json"});
  }

  // delete patient otp details by mobile number
  deletePatientOtpDetails(mobilenumber:any)  {
    let url = PATIENT_URL+"/deleteotpverificationentry/"+mobilenumber;
    return this.httpClient.get(url, {responseType: "text"});
  }

  // get video consult package list
  getVideoConsultPackageList(docuid:any)  {
    let url = SWASTHPLUS+"/getplackgeplanlist/"+docuid;
    return this.httpClient.get(url, {responseType: "json"});
  }

  // get razor pay payment link details
  getRazorpayPaymentLinkDetails(razorpayObj:any){
    var epurl=BILL_URL+"/getpaymentdetails";
    console.log("url......"+epurl);
    return this.httpClient.post(epurl, razorpayObj, {responseType: "json"});
  }

  // update success notification status
  updateSuccessNotificationStatus(razorpayid:any)  {
    let url = BILL_URL+"/updatesuccessnotification/"+razorpayid;
    return this.httpClient.get(url, {responseType: "text"});
  }

   getAgoraDetailsByDoctorJoinCode(joincode:any,type:any)
  {
    var epurl=LOOKUP_URL+"/getagoradetailsbycode/"+joincode+"/"+type;
    console.log("body", epurl);
    return this.httpClient.get(epurl, {responseType: 'json'});
  }

  getVideoAppointmentbypaymentlink(paymentLink:any)
  {
    let url = SWASTHPLUS+"/getvideoappointmentbyrazlink/";
    return this.httpClient.post(url,paymentLink, {responseType: "json"});
  }

  sendappointmentconfirmedvideoconsult(searchTerm){
    var epurl=PATIENT_URL+"/appointmentconfirmedvideoconsult";
    return this.httpClient.put(epurl, searchTerm, {responseType: "text"})
    .pipe(
      catchError((err) => {
        SWASTH_CONST.apiErrorHandling(err);
        return throwError(err); 
      })
    )
  }

  senddoctorpaymentconfirmationvideoconsult(searchTerm){
    var epurl=PATIENT_URL+"/doctorpaymentconfirmationvideoconsult";
    return this.httpClient.put(epurl, searchTerm, {responseType: "text"})
    .pipe(
      catchError((err) => {
        SWASTH_CONST.apiErrorHandling(err);
        return throwError(err); 
      })
    )
  }
  // hospital patient detail by hospital pateient primry id
  getHospPtDetailByuhid(uhid:any) {
    let url = SWASTHCONFIG.PATIENT_URL+"/patientsuid/"+uhid;
    return this.httpClient.get(url, {responseType: "json"});    
  } 

  getHospIdByUserTenantID(userid:any, tenantid:any):Observable<any>{
    var epurl=PATIENT_URL+"/hospidbytuid/"+tenantid+"/"+userid;
    return this.httpClient.get(epurl, {responseType: "json"});
  }

   activateVideoAppoinemnt(vchatapptid:any)
  {
    let url = SWASTHPLUS+"/activatevideoappoinemnt/"+vchatapptid;
    return this.httpClient.get(url, {responseType: "text"});
  }

  getsinglevideoappointment(apptObj:any) {
    var epurl = SWASTHCONFIG.SWASTHPLUS + "/getsinglevideoappointmentnewbranch";
    return this.httpClient.put(epurl, apptObj, { responseType: "json" })
    .pipe(
      catchError((err) => {
        SWASTH_CONST.apiErrorHandling(err);
        return throwError(err); 
      })
    )
  }

}
